import basket_icon from './basket_icon.png'
import logo from './logo.png'
import logo1 from './Logo1.png'
import search_icon from './search_icon.png'
import menu_1 from './Whole_Spices.jpg'
import menu_2 from './Powder_Spices.jpg'
import menu_3 from './Oleorisins.jpeg'
import menu_4 from './About_Spices.jpg'



import black_pepper from '../Products_assets/pepper.jpg'
import clove from '../Products_assets/clove.jpg'
import star_anise from '../Products_assets/Star_anise.jpg'
import chiili_powder from '../Products_assets/Chilli_powder.jpg'
import black_pepper_powder from '../Products_assets/pepper_powder.jpg'
import white_pepper_powder from '../Products_assets/white_powder.jpg'
import turmeric_powder from '../Products_assets/turmeric_powder.jpg'
import white_pepper from '../Products_assets/white_pepper.jpg'
import cardamom from '../Products_assets/Cardamom.jpg'
import turmeric from '../Products_assets/raw_turmeric.jpg'
import ginger from '../Products_assets/dry_ginger.jpg'
import brine from '../Products_assets/brine_pepper.jpg'
import kashmiri_chilli from '../Products_assets/kashmiri_chilli.jpg'
import nutmeg from '../Products_assets/Nutmeg.jpg'
import b_cardamom from '../Products_assets/black_cardamom.jpg'
import white_tea from '../Products_assets/White_tea.jpg'
import dry_onions from '../Products_assets/dry_onions.jpg'
import jaggery from '../Products_assets/jaggery.jpg'
import mustard from '../Products_assets/Mustard.jpeg'
import chai from '../Products_assets/chai.png'
import cardamom_extract from '../Products_assets/cardamom_extract.png'
import pepper_extract from '../Products_assets/pepper_extract.png'
import cinnamon_extract from '../Products_assets/Cinnamon_extract.png'
import clove_extract from '../Products_assets/Clove_extract.png'
import ginger_extract from '../Products_assets/ginger_extract.png'
import cashew from '../Products_assets/cashew.jpg'
import coconut_oil from '../Products_assets/Cocunut_oil.jpg'
import bay_leaves from '../Products_assets/Bay_leaves.jpg'






import add_icon_white from './add_icon_white.png'
import add_icon_green from './add_icon_green.png'
import remove_icon_red from './remove_icon_red.png'
import linkedin_icon from './linkedin_icon.png'
import facebook_icon from './facebook_icon.png'
import twitter_icon from './twitter_icon.png'
import cross_icon from './cross_icon.png'
import selector_icon from './selector_icon.png'
import rating_starts from './rating_starts.png'
import profile_icon from './profile_icon.png'
import bag_icon from './bag_icon.png'
import logout_icon from './logout_icon.png'
import logo_text from './logo-300x124.png'

export const assets = {
    logo,
    logo1,
    basket_icon,
    search_icon,
    rating_starts,
    add_icon_green,
    add_icon_white,
    remove_icon_red,
    linkedin_icon,
    facebook_icon,
    twitter_icon,
    cross_icon,
    selector_icon,
    profile_icon,
    logout_icon,
    bag_icon,
    logo_text
}

export const menu_list = [
    {
        menu_name: "Raw Spices",
        menu_image: menu_1
    },
    {
        menu_name: "Powder Spices",
        menu_image: menu_2
    },
    {
        menu_name: "Oleoresins",
        menu_image: menu_3
    },
    {
        menu_name: "Others",
        menu_image: menu_4
    }



]

export const food_list = [







    {
        _id: "1",
        name: "Black Pepper",
        name1: "Schwarzer Pfeffer",
        name2: "کالی مرچ",
        image: black_pepper,
        price: 12,
        description: "Authentic Black Pepper from Kerala Known as the “King of Spices,” black pepper sourced from Kerala holds a legendary reputation for its superior quality and rich aroma. Grown in the lush hills of Kerala, under ideal tropical conditions, our black pepper is hand-harvested by local farmers using sustainable practices. Kerala’s unique soil and climate impart a bold flavor and pungency to the pepper, making it a global favorite. We ensure it is 100% natural, free from chemicals, and sourced directly from farmers, preserving its authenticity and freshness.Experience the true essence of premium black pepper.",
        category: "Raw Spices"
    },
    {
        _id: "2",
        name: "Clove",
        name1: "Nelke",
        name2: "لونگ",
        image: clove,
        price: 18,
        description: "Premium Cloves from Kerala, renowned for its spice heritage, produces some of the finest cloves in the world. Cultivated in the fertile soils and tropical climate of Kerala’s highlands, our cloves are hand-picked by experienced farmers who uphold traditional and sustainable farming practices. These aromatic buds are celebrated for their intense flavor, warm aroma, and exceptional quality. Our cloves are 100% natural, free from chemicals, and sourced directly from local farmers, ensuring authenticity and freshness in every batch. Discover the richness of premium cloves, sourced from the spice-rich lands of Kerala.",
        category: "Raw Spices"
    },

    {
        _id: "3",
        name: "Star Anise",
        name1: "Steranis",
        name2: "لونگ",
        image: star_anise,
        price: 16,
        description: "Exquisite Star Anise from Kerala Sourced from the spice-rich regions of Kerala, our star anise stands out for its vibrant aroma, bold flavor, and unmatched quality. Grown in the lush tropical climate and nutrient-rich soils of Kerala, this iconic spice is carefully hand-harvested by skilled farmers who follow sustainable and traditional methods. Known for its distinct star-shaped appearance and sweet, licorice-like taste, our star anise is 100% natural, free from chemicals, and sourced directly from trusted local farmers. Experience the authenticity and superior quality of Kerala’s star anise.",
        category: "Raw Spices"
    },

    {
        _id: "4",
        name: "Chilli Powder",
        name1: "Kaschmir-Chili",
        name2: "مرچ پاؤڈر",
        image: chiili_powder,
        price: 24,
        description: "Authentic Guntur Chili Powder. Igniting flavors, from the Chili Capital of India, Experience the bold, aromatic flavor of authentic Guntur chili powder, sourced directly from the renowned chili-producing region of Guntur, Andhra Pradesh. Our chili powder is made from high-quality, locally-grown chilies, carefully selected and processed to preserve their natural flavor and heat.- Sourced from Guntur, India's largest chili-producing region, Made from high-quality, locally-grown chilies, Distinctive bold, aromatic flavor and medium to hot heat level, Supports local farmers and sustainable agriculture practices",
        category: "Powder Spices"
    },

    {
        _id: "5",
        name: "Black Pepper Powder",
        name1: "Schwarzes pfefferpulver",
        name2: "کالی مرچ پاؤڈر",
        image: black_pepper_powder,
        price: 14,
        description: "Authentic Idukki Pepper Powder. Elevate your dishes with the finest pepper from God's Own Country. Experience the rich, aromatic flavor of authentic Idukki pepper powder, sourced from the lush, humid climate of Idukki, Kerala. Our pepper powder is made from high-quality, locally-grown peppercorns, carefully selected and processed to preserve their natural flavor and aroma. Sourced from Idukki, Kerala's premier pepper-producing region, Made from high-quality, locally-grown peppercorns, Distinctive rich, aromatic flavor and moderate heat level, Supports local farmers and sustainable agriculture practices",
        category: "Powder Spices"
    },

    {
        _id: "6",
        name: "White Pepper Powder",
        name1: "Weibes Pfefferpulver",
        name2: "سفید مرچ پاؤڈر",
        image: white_pepper_powder,
        price: 12,
        description: "Authentic Idukki White Pepper Powder. Unlock the subtle charm of India's finest white pepper. Experience the delicate, creamy flavor of authentic Idukki white pepper powder, sourced from the lush, humid climate of Idukki, Kerala. Our white pepper powder is made from high-quality, locally-grown white peppercorns, carefully selected and processed to preserve their natural flavor and aroma. Sourced from Idukki, Kerala's premier pepper-producing region, Made from high-quality, locally-grown white peppercorns, Distinctive delicate, creamy flavor and mild heat level, Supports local farmers and sustainable agriculture practices",
        category: "Powder Spices"
    },

    {
        _id: "7",
        name: "Turmeric Powder",
        name1: "Kurkumapulver",
        name2: "ہلدی پاؤڈر",
        image: turmeric_powder,
        price: 20,
        description: "Authentic Central Kerala Turmeric Powder. Unlock the golden goodness of India's finest turmeric. Experience the vibrant, warm flavor of authentic Central Kerala turmeric powder, sourced from the lush, humid climate of Central Kerala. Our turmeric powder is made from high-quality, locally-grown turmeric roots, carefully selected and processed to preserve their natural flavor, aroma, and medicinal properties. Sourced from Central Kerala, renowned for its rich turmeric heritage, Made from high-quality, locally-grown turmeric roots, Distinctive vibrant, warm flavor and numerous health benefits, Supports local farmers and sustainable agriculture practices",
        category: "Powder Spices"
    }, {
        _id: "8",
        name: "white pepper",
        name1: "Weiber Pfeffer",
        name2: "سفید مرچ",
        image: white_pepper,
        price: 15,
        description: "Finest White Pepper from the Western Ghats of Kerala. Our white pepper is sourced from the pristine Western Ghats of Kerala, a region celebrated for its rich biodiversity and fertile soils. Produced from fully ripened pepper berries, it undergoes a meticulous process of soaking, peeling, and drying, resulting in a milder, earthy flavor and smooth heat. Cultivated by skilled farmers using traditional and sustainable methods, our white pepper is 100% natural, free from chemicals, and sourced directly from the lush spice plantations of Kerala. Experience the subtle elegance of premium white pepper, crafted with care in the heart of Kerala’s Western Ghats.",
        category: "Raw Spices"
    }, {
        _id: "9",
        name: "Green Cardamom",
        name1: "Gruner Kardamom",
        name2: " سبز الائچی",
        image: cardamom,
        price: 14,
        description: "Premium Green Cardamom from the Hills of Kerala. Sourced from the lush hill regions of Kerala, our green cardamom is a testament to nature’s finest offerings. Grown in the cool, misty climate of the Western Ghats, this “Queen of Spices” boasts a distinctive aroma, intense flavor, and unparalleled quality. Hand-harvested by skilled farmers using traditional and sustainable practices, our cardamom is 100% natural and free from chemicals. The fertile soil and unique microclimate of Kerala’s hill areas ensure that every pod delivers exceptional freshness and authenticity. Elevate your culinary creations with the richness of premium green cardamom, straight from Kerala’s scenic highlands.",
        category: "Raw Spices"
    }, {
        _id: "10",
        name: "Turmeric",
        name1: "Kurkuma",
        name2: "ہلدی",
        image: turmeric,
        price: 22,
        description: "Pure Turmeric from Central Kerala’s Tropical Heart. Sourced from the fertile lands of central Kerala, our turmeric is a true reflection of the region’s tropical climate and rich soil. Known for its vibrant golden hue and potent aroma, this turmeric is cultivated by local farmers dedicated to sustainable and traditional agricultural practices. Renowned for its high curcumin content, our turmeric is 100% natural, chemical-free, and processed to preserve its exceptional quality and freshness. Add a touch of purity and wellness to your life with premium turmeric, straight from the tropical heart of Kerala.",
        category: "Raw Spices"
    }, {
        _id: "11",
        name: "Dried Ginger",
        name1: "Getrockneter Ingwer",
        name2: "سونٹھ",
        image: ginger,
        price: 10,
        description: "Premium Dried Ginger from Kerala’s Malabar Region. Sourced from the lush Malabar region of Kerala, our dried ginger embodies the richness of the area’s humid climate and fertile soil. Renowned for its bold flavor, zesty aroma, and therapeutic properties, this ginger is cultivated by skilled farmers using traditional, sustainable methods. Carefully harvested and naturally dried, our ginger is 100% pure, free from chemicals, and retains its potency and freshness. Perfect for culinary, medicinal, or wellness applications, it delivers unmatched quality straight from Kerala’s spice-rich Malabar coast. Experience the essence of authentic dried ginger, crafted by nature and tradition.",
        category: "Raw Spices"
    }, {
        _id: "12",
        name: "Pepper in Brine",
        name1: "Pfeffer in Salzlake",
        name2: "نمکین مرچ",
        image: brine,
        price: 12,
        description: "Authentic Central Kerala Pepper in Brine. Harvested with love, preserved with care. Experience the distinct flavor of Central Kerala's finest pepper, carefully handpicked from the lush, humid climate of the region. Our pepper in brine is made from the highest quality peppercorns, sourced directly from local farmers and preserved in a traditional brine solution. Sourced from Central Kerala's humid climate, known for its unique terroir, Handpicked, high-quality peppercorns for maximum flavor, Traditional brine solution preserves the pepper's natural flavor and aroma, Supports local farmers and sustainable agriculture practices",
        category: "Raw Spices"
    },
    {
        _id: "13",
        name: "Kashmiri Chilli",
        name1: "Kaschmir-Chili",
        name2: "کشمیری مرچ",
        image: kashmiri_chilli,
        price: 12,
        description: "Authentic Kashmiri Chilies. Adding warmth to your dishes, from the Valley of Heaven. Experience the signature mild heat and vibrant red color of authentic Kashmiri chilies, sourced directly from the picturesque Valley of Kashmir. Our chilies are carefully handpicked from local farms, nurtured in the region's distinct humid climate and fertile soil. Sourced from the Kashmir Valley, renowned for its unique terroir, Handpicked, high-quality chilies for maximum flavor and color, Mild heat and sweet, slightly smoky flavor profile, Supports local farmers and sustainable agriculture practices",
        category: "Raw Spices"
    },
    {
        _id: "14",
        name: "Nutmeg",
        name1: "Muskatnuss",
        name2: "جائفل",
        image: nutmeg,
        price: 12,
        description: "Exquisite Nutmeg from Idukki, Kerala. Grown in the humid, fertile hills of Idukki, Kerala, our nutmeg is a true symbol of premium quality and rich flavor. This spice thrives in the region’s ideal tropical climate, ensuring its bold aroma, warm taste, and superior freshness. Cultivated by skilled farmers using sustainable practices, our nutmeg is carefully hand-harvested and processed to preserve its natural goodness. Free from chemicals, it is perfect for enhancing both sweet and savory dishes. Discover the unmatched richness of nutmeg, sourced directly from the Kerala.",
        category: "Raw Spices"
    },

    {
        _id: "15",
        name: "Black cardamom",
        name1: "Schwarzer Kardamom",
        name2: "کالی الائچی",
        image: b_cardamom,
        price: 12,
        description: "Sourced from the lush, humid regions of Siliguri, our black cardamom is celebrated for its bold, smoky flavor and aromatic intensity. Grown in the fertile soils and misty climate of this region, each pod is carefully hand-harvested and dried using traditional methods to preserve its unique taste and quality. Perfect for enhancing savory dishes, our black cardamom is 100% natural, free from chemicals, and sourced directly from farmers who follow sustainable agricultural practices. Elevate your culinary creations with the authentic, robust flavor of premium black cardamom from Siliguri.",
        category: "Others"
    },

    {
        _id: "16",
        name: "White tea",
        name1: "Weißer Tee",
        name2: "سفید چائے",
        image: white_tea,
        price: 12,
        description: "Sourced from the misty, humid hills of Darjeeling, our white tea is a rare and delicate treasure. Handpicked from the youngest tea buds, it is minimally processed to preserve its natural sweetness, floral aroma, and smooth, refreshing flavor. Grown in the fertile soils and cool climate of Darjeeling, this tea is a symbol of purity and craftsmanship. Rich in antioxidants and free from chemicals, it offers a premium tea experience that supports both health and sustainability. Discover the elegance of authentic white tea, sourced from the renowned tea gardens of Darjeeling.",
        category: "Others"
    },


    {
        _id: "17",
        name: "Dry onions",
        name1: "Getrocknete Zwiebeln",
        name2: "خشک پیاز",
        image: dry_onions,
        price: 12,
        description: "Sourced from the vibrant fields of Nagpur, our dried onions are a testament to the region’s humid climate and rich agricultural heritage. Carefully processed from fresh, high-quality onions, they retain their natural flavor, aroma, and nutritional value. Ideal for enhancing a variety of dishes, our dried onions are 100% natural, free from chemicals, and sourced directly from trusted farmers in Nagpur. Convenient and long-lasting, they bring authentic taste and freshness to your kitchen. Experience the convenience and richness of premium dried onions, straight from Nagpur’s fertile lands.",
        category: "Others"
    },


    {
        _id: "18",
        name: "Mustard",
        name1: "Senf",
        name2: "سرسوں",
        image: mustard,
        price: 12,
        description: "Sourced from the fertile fields of Murshidabad in West Bengal, our mustard seeds thrive in the region’s humid climate, ensuring their bold flavor, rich aroma, and superior quality. Carefully cultivated by local farmers using sustainable practices, these seeds are a cornerstone of traditional Indian cooking. Known for their vibrant taste and nutritional benefits, our mustard seeds are 100% natural and chemical-free. Perfect for tempering, marinades, or mustard oil extraction, they bring authenticity and freshness to every dish. Discover the essence of premium mustard, sourced directly from the spice-rich heart of West Bengal.",
        category: "Others"
    },


    {
        _id: "19",
        name: "Jaggery",
        name1: "Rohrzucker",
        name2: "گڑ",
        image: jaggery,
        price: 12,
        description: "Sourced from the fertile lands of Theni, Tamil Nadu, our jaggery is crafted from fresh sugarcane grown in the region’s humid tropical climate. Known for its rich caramel-like sweetness and deep golden hue, it is made using traditional methods to retain its natural minerals and nutrients. Free from chemicals and additives, our jaggery is 100% pure and sourced directly from local farmers dedicated to sustainable practices. Perfect for sweetening desserts, beverages, or traditional recipes, it offers authentic taste and health benefits in every bite. Experience the wholesome goodness of premium jaggery, straight from Theni’s lush fields.",
        category: "Others"
    },


    {
        _id: "20",
        name: "Chai Masala",
        name1: "Chai-Gewürz",
        name2: "چائے مسالا",
        image: chai,
        price: 12,
        description: "Crafted with precision, our chai masala blends premium spices to create the perfect aromatic mix for your tea. Featuring cardamom, cinnamon, cloves, and more, it delivers a warm and invigorating flavor. Free from artificial colors and preservatives, it is carefully sourced and blended to ensure freshness and quality. Perfect for transforming your tea into a comforting experience, this masala embodies tradition and authenticity in every sip. Rich in antioxidants and health benefits, it aids digestion and boosts immunity. Whether you're brewing a traditional cup or experimenting with new recipes, our chai masala brings a burst of warmth and flavor to every brew.",
        category: "Oleoresins"
    },

    {
        _id: "21",
        name: "Pepper Extract",
        name1: "Pfefferextrakt",
        name2: "مرچ کا عرق",
        image: pepper_extract,
        price: 12,
        description: "Derived from the finest black peppercorns, our pepper extract is packed with the natural pungency and warmth of this versatile spice. Sourced from sustainable farms, it is carefully processed to preserve its active compounds and aromatic oils. Perfect for enhancing soups, marinades, and sauces, it adds depth and richness to your recipes. Free from chemicals and additives, our pepper extract delivers pure flavor and health benefits in every drop. Experience the intensity of premium black pepper in its most concentrated form. Rich in antioxidants, it also aids digestion and supports metabolism, making it a flavorful and beneficial addition to any dish.",
        category: "Oleoresins"
    },

    {
        _id: "22",
        name: "Cardamom Extract",
        name1: "Kardamomextrakt",
        name2: "الائچی کا عرق",
        image: cardamom_extract,
        price: 12,
        description: "Sourced from the finest green cardamom pods, our cardamom extract captures the aromatic sweetness and spicy warmth of this cherished spice. Carefully processed to retain its natural essential oils, it is perfect for flavoring desserts, beverages, and savory dishes. Free from chemicals and artificial additives, it offers purity and depth in every drop. Experience the true essence of premium cardamom, sourced sustainably and crafted with care. Rich in antioxidants and digestive benefits, it enhances not only flavor but also wellness. Ideal for enhancing teas, cakes, and curries, our cardamom extract brings a distinctive, fragrant touch to your culinary creations.",
        category: "Oleoresins"
    },

    {
        _id: "23",
        name: "Cinnamon Extract",
        name1: "Zimtextrakt",
        name2: "دار چینی کا عرق",
        image: cinnamon_extract,
        price: 12,
        description: "Crafted from the finest cinnamon bark, our cinnamon extract embodies the warm, woody sweetness of this beloved spice. Known for its rich aroma and versatile flavor, it enhances desserts, beverages, and savory dishes alike. Made using traditional methods to preserve its natural oils and nutrients, it is free from chemicals and artificial additives. Sourced sustainably, our cinnamon extract offers authentic taste and health benefits with every use. Packed with antioxidants and anti-inflammatory properties, it supports digestion and promotes overall well-being. Perfect for creating aromatic teas, baked goods, or flavorful sauces, our premium cinnamon extract brings a rich.",
        category: "Oleoresins"
    },

    {
        _id: "24",
        name: "Clove Extract",
        name1: "Nelkenextrakt",
        name2: "لونگ کا عرق",
        image: clove_extract,
        price: 12,
        description: "Extracted from high-quality clove buds, our clove extract delivers an intense, warm flavor and unmistakable aroma. Known for its rich essential oils and numerous health benefits, it is perfect for spicing up beverages, baked goods, and savory dishes. Free from artificial additives and sustainably sourced, it retains its natural potency and purity. Carefully crafted to ensure a balance of taste and aroma, it blends seamlessly into marinades, curries, and desserts, elevating both flavor and nutrition. Packed with antioxidants and anti-inflammatory properties, our clove extract offers a natural way to enhance your health while enjoying its robust, authentic taste.",
        category: "Oleoresins"
    },


    {
        _id: "19",
        name: "Ginger Extract",
        name1: "Ingwerextrakt",
        name2: "ادرک کا عرق",
        image: ginger_extract,
        price: 12,
        description: "Sourced from fresh, aromatic ginger roots, our ginger extract offers the zesty, spicy warmth of this versatile ingredient. Carefully processed to retain its natural flavor and health-enhancing properties, it is ideal for teas, marinades, desserts, and even savory dishes. Packed with antioxidants and anti-inflammatory benefits, it is perfect for boosting immunity and adding a robust flavor to your culinary creations. Free from chemicals and artificial additives, it is crafted with a focus on purity, freshness, and quality. Sourced from sustainable farms, our ginger extract delivers a rich, authentic taste that transforms your recipes.",
        category: "Oleoresins"
    },

    {
        _id: "20",
        name: "Cashew Nuts",
        name1: "Cashewnüsse",
        name2: "کاجو",
        image: cashew,
        price: 12,
        description: "Sourced from the renowned cashew plantations of Kollam, Kerala, our cashew nuts are celebrated for their superior quality, creamy texture, and rich flavor. Grown in the ideal tropical climate of the region, each cashew is carefully handpicked and processed to ensure maximum freshness and taste. Our cashews are 100% natural, free from chemicals, and sourced directly from trusted farmers, reflecting Kerala’s legacy of producing the finest cashew nuts. Perfect for snacking, cooking, or baking, they bring premium quality to every occasion.",
        category: "Others"
    },

    {
        _id: "21",
        name: "Cold-Pressed Coconut Oil",
        name1: "Kaltgepresstes Kokosöl",
        name2: "ناریل کا سرد دبایا ہوا تیل",
        image: coconut_oil,
        price: 12,
        description: "Our cold-pressed coconut oil is sourced from the lush coconut groves of Central Kerala, renowned for its ideal climate and fertile soil. Extracted using traditional methods that preserve the oil’s natural goodness, it retains all the nutrients, antioxidants, and healthy fats that make it a staple in both kitchens and wellness routines. 100% natural and free from chemicals, our coconut oil is a versatile product, perfect for cooking, skincare, and hair care. Sourced directly from local farmers who practice sustainable farming, it embodies the purity and authenticity of Kerala’s rich coconut heritage. Experience the purity and benefits of premium cold-pressed coconut oil, straight from the heart of Kerala.",
        category: "Others"
    },
    
    {
        _id: "22",
        name: "Bay Leaves",
        name1: "Lorbeerblätter",
        name2: "تیز پات",
        image: bay_leaves,
        price: 12,
        description: "Fragrant and flavorful, bay leaves are a kitchen essential, known for their subtle herbal aroma and slightly bitter taste that enhance the depth of soups, stews, sauces, and marinades. These premium-quality leaves are handpicked to ensure optimal flavor and freshness, making them perfect for slow-cooked dishes, rice preparations, and spice blends. Beyond their culinary uses, bay leaves are traditionally valued for aiding digestion and boosting wellness. Simply add whole leaves while cooking and remove them before serving. Ideal for curries, broths, and roasted meats, bay leaves elevate every recipe with their aromatic, sophisticated touch. Upgrade your dishes today!",
        category: "Others"
    },


]
